<template>
  <v-container>
    <v-layout justify-center>
      <v-flex lg6 md8 sm8 xs12>
        <v-card>
          <v-form>
            <v-card-title>
              {{ title }}
            </v-card-title>

            <v-card-text>
              <v-layout wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label="IP"
                    :disabled="$store.state.query.loading"
                    v-model="ip"
                  ></v-text-field>

                  <v-text-field
                    label="İsim"
                    :disabled="$store.state.query.loading"
                    v-model="name"
                  ></v-text-field>

                  <v-text-field
                    label="Unique ID"
                    :disabled="$store.state.query.loading"
                    v-model="uid"
                  ></v-text-field>

                  <v-textarea
                    label="Sebep"
                    v-model="reason"
                    :disabled="$store.state.query.loading"
                  >
                  </v-textarea>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    type="number"
                    label="Süre"
                    :disabled="!selectedUnit || $store.state.query.loading"
                    v-model="time"
                  ></v-text-field>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-autocomplete
                    :items="timeUnits"
                    :disabled="$store.state.query.loading"
                    v-model="selectedUnit"
                    label="Birim"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text
                @click="addBan"
                :disabled="disabledButton"
                color="primary"
              >
                Tamam
              </v-btn>

              <v-btn text @click="$router.go(-1)" color="primary">
                İptal
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
    ban: Object, // client veya ban objesi
  },
  data() {
    return {
      timeUnits: [
        { text: "saniye", value: 1 }, // value = saniye
        { text: "dakika", value: 60 },
        { text: "saat", value: 3600 },
        { text: "gün", value: 86400 },
        { text: "kalıcı", value: 0 },
      ],
      selectedUnit: 1,
    };
  },
  computed: {
    ip: {
      get() {
        return this.ban.ip;
      },
      set(ip) {
        this.ban.ip = ip;
      },
    },
    name: {
      get() {
        return this.ban.name;
      },
      set(name) {
        this.ban.name = name;
      },
    },
    uid: {
      get() {
        return this.ban.uid;
      },
      set(uid) {
        this.ban.uid = uid;
      },
    },
    reason: {
      get() {
        return this.ban.reason;
      },
      set(reason) {
        this.ban.reason = reason;
      },
    },
    time: {
      get() {
        return this.ban.time;
      },
      set(time) {
        this.ban.time = +time;
      },
    },
    disabledButton() {
      if (this.ip || this.name || this.uid) return false;
      return true;
    },
  },
  methods: {
    addBan() {
      this.$emit("addban", {
        ...this.ban,
        time: this.time * this.selectedUnit,
      });
    },
    getOptimalTimeUnit(seconds) {
      let unit = "";

      if (!seconds) {
        unit = "kalıcı";
      } else if (Number.isInteger(seconds / 86400)) {
        unit = "gün";
      } else if (Number.isInteger(seconds / 3600)) {
        unit = "saat";
      } else if (Number.isInteger(seconds / 60)) {
        unit = "dakika";
      } else {
        unit = "saniye";
      }

      return unit;
    },
    setOptimalTimeUnit(seconds) {
      let timeUnit = this.getOptimalTimeUnit(seconds);

      switch (timeUnit) {
        case "kalıcı":
          this.selectedUnit = 0;
          break;
        case "gün":
          this.selectedUnit = 86400;
          break;
        case "saat":
          this.selectedUnit = 3600;
          break;
        case "dakika":
          this.selectedUnit = 60;
          break;
        default:
          this.selectedUnit = 1;
      }
    },
    init() {
      let unwatchTime = this.$watch(
        "time",
        (seconds) => {
          if (seconds !== undefined) {
            this.setOptimalTimeUnit(seconds);

            // "immediate" yüzünden ilk tetiklenmede düzgün ayarlamak için
            this.$nextTick(() => {
              unwatchTime();

              this.ban.time = seconds / this.selectedUnit;
            });
          }
        },
        { immediate: true }
      );
    },
  },
  created() {
    this.init();
  },
};
</script>
